import {fromJS} from "immutable"
import {
  TOGGLE_CARD_ACTIVE,
} from "../constants/actionTypes"
import {isObjectsSame} from "../helpers/common";
import {menuInitialState} from '../helpers/menu';


const toggleCardActive = (state, payload) => {
  const menuCards = state.toJS();
  let i = 0;
  for (i; i < menuCards.length; ++i) {
    const card = menuCards[i].find((card) => isObjectsSame(card, payload));
    if (card) {
      card.active = !payload.active;
      break;
    }
  }

  return fromJS(menuCards);
};

export default function menu(state = menuInitialState, action) {
  switch (action.type) {
    case TOGGLE_CARD_ACTIVE:
      return toggleCardActive(state, action.payload);
    default:
      return state
  }
}